export default __webpack_public_path__ + "media/color/ins-0ba96b8f.svg";